import React, { useState, useEffect, useRef, useCallback } from "react";
import ReactDOM from "react-dom";

import { useNavigate } from 'react-router-dom';

import SupportEmail from "./SupportEmail";
import "../styles/message-map.css";

const MessageMap = () => {
  const [isPlacingMessage, setIsPlacingMessage] = useState(false);
  const [coordinates, setCoordinates] = useState({ x: 0, y: 0 });
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [username, setUsername] = useState('');
  const [paymentId, setPaymentId] = useState('');
  const [loginStatus, setLoginStatus] = useState('');
  const [statusColor, setStatusColor] = useState('#666');
  const [messageType, setMessageType] = useState('text');
  const [messageText, setMessageText] = useState('');
  const [expirationTime, setExpirationTime] = useState(10);
  const [audioChunks, setAudioChunks] = useState([]);
  const [isRecording, setIsRecording] = useState(false);
  const [recordingTime, setRecordingTime] = useState('0:00');
  const [recordingStatus, setRecordingStatus] = useState('');
  const [messages, setMessages] = useState([]);
  const [activePopup, setActivePopup] = useState(null);
  const [decodedMessages, setDecodedMessages] = useState({});
  const [autoDecodingIds, setAutoDecodingIds] = useState(new Set());
  const [encodingKeyNotification, setEncodingKeyNotification] = useState(null);
  const [notificationTimeout, setNotificationTimeout] = useState(null);
  const [userTokens, setUserTokens] = useState(0);
  const [zoomLevel, setZoomLevel] = useState(1);
  
  const [gridMoveIndicator, setGridMoveIndicator] = useState({ active: false, direction: '' });
  const [scrollProgress, setScrollProgress] = useState({ horizontal: 50, vertical: 50 });
  const [focusedOnMessage, setFocusedOnMessage] = useState(false);

  const [focalMessage, setFocalMessage] = useState(null);
  const [preservedCoordinates, setPreservedCoordinates] = useState(null);
  const [isDraggingFromMessage, setIsDraggingFromMessage] = useState(false);
  const [jumpError, setJumpError] = useState('');
  const [isJumpAnimating, setIsJumpAnimating] = useState(false);
  const [jumpDotKey, setJumpDotKey] = useState(0);
  const [isMobileView, setIsMobileView] = useState(false);
  const [activeTab, setActiveTab] = useState('map');
  const [showMobileDragHint, setShowMobileDragHint] = useState(false);
  const [hasDragged, setHasDragged] = useState(false);
  const [jumpCoordinateInput, setJumpCoordinateInput] = useState('');
  const [jumpSuccessMessage, setJumpSuccessMessage] = useState(null);
const [hiddenMessages, setHiddenMessages] = useState(new Set());

const [userSessionId, setUserSessionId] = useState('');

const navigate = useNavigate();
const redirectToReportPage = (message) => {
  if (!isLoggedIn) {
    alert('Please login to report messages');
    return;
  }

  // Navigate to report page with message data
  navigate('/report', { 
    state: { 
      message: message,
      decodedContent: decodedMessages[message.id] || null,
      apiUrl: apiUrl
    } 
  });
};
  const lastMessageCoordinatesRef = useRef(null);
  const dragCountRef = useRef(0);
  const draggingStartedRef = useRef(false);
  
  const mapRef = useRef(null);
  const gridBackgroundRef = useRef(null);
  const audioRecorderRef = useRef(null);
  const recordingIntervalRef = useRef(null);
  const recordingStartTimeRef = useRef(0);
  const audioPreviewRef = useRef(null);
  
  const gridMoveTimeout = useRef(null);
  const activeCellsRef = useRef([]);
  const cellUpdateInterval = useRef(null);
  const [jumpDot, setJumpDot] = useState(null);
  
  const touchStartRef = useRef({ x: 0, y: 0 });
  const lastTouchRef = useRef({ x: 0, y: 0 });
  const isTouchDraggingRef = useRef(false);
  const touchTimeRef = useRef(0);
  const hasInitialFocusRef = useRef(false);

  const apiUrl = 'https://api.omegavoid.com';
  const MAX_RECORDING_TIME = 5 * 60 * 1000;
  
  const GRID_SIZE = 1000000000;
  const GRID_CENTER = GRID_SIZE / 2;
  const VISIBLE_GRID_SIZE = 100;
  const CELL_SIZE = 20;
useEffect(() => {
  const storedHiddenMessages = localStorage.getItem('hiddenMessages');
  if (storedHiddenMessages) {
    try {
      const hiddenArray = JSON.parse(storedHiddenMessages);
      setHiddenMessages(new Set(hiddenArray));
    } catch (e) {
      console.error('Error loading hidden messages:', e);
    }
  }

  // Load user session ID
  const sessionId = localStorage.getItem('tempUserId');
  if (sessionId) {
    setUserSessionId(sessionId);
  }
}, []);

// Save hidden messages to localStorage whenever it changes
useEffect(() => {
  if (hiddenMessages.size === 0) {
    // If no hidden messages, remove from localStorage
    localStorage.removeItem('hiddenMessages');
  } else {
    // Save to localStorage
    const hiddenArray = [...hiddenMessages];
    localStorage.setItem('hiddenMessages', JSON.stringify(hiddenArray));
    console.log('Saved hidden messages to localStorage:', hiddenArray);
  }
}, [hiddenMessages]);


const filteredMessages = React.useMemo(() => {
  const filtered = messages.filter(message => {
    const isHidden = hiddenMessages.has(message.id);
    if (isHidden) {
      console.log('Filtering out hidden message:', message.id);
    }
    return !isHidden;
  });
  
  console.log(`Total messages: ${messages.length}, Hidden: ${hiddenMessages.size}, Filtered: ${filtered.length}`);
  return filtered;
}, [messages, hiddenMessages]);


// Delete/Hide message function
const deleteMessage = async (message) => {
  if (!isLoggedIn) {
    alert('Please login to manage messages');
    return;
  }

  const authToken = localStorage.getItem('authToken');
  const sessionId = localStorage.getItem('tempUserId');

  // Check if user is the creator (using session ID comparison)
  const isCreator = message.user_session_id === sessionId;

  if (isCreator) {
    // Creator can delete from server
    if (window.confirm('Are you sure you want to permanently delete this message? This action cannot be undone.')) {
      try {
        const deleteData = {
          type: 'delete'
          // No user_session_id needed - backend gets it from sessions table
        };

        const response = await fetch(`${apiUrl}/messages/${message.id}`, {
          method: 'DELETE',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': authToken
          },
          body: JSON.stringify(deleteData)
        });

        if (response.ok) {
          // Remove from local state and refresh messages
          setMessages(prevMessages => prevMessages.filter(m => m.id !== message.id));
          
          // Close popup and clear jump dot if needed
          if (activePopup && activePopup.message.id === message.id) {
            closePopup();
          }
          
          if (jumpDot && jumpDot.message && jumpDot.message.id === message.id) {
            setJumpDot(null);
          }
          
          alert('Message deleted successfully.');
        } else {
          const data = await response.json();
          alert(`Error deleting message: ${data.error || 'Unknown error'}`);
        }
      } catch (error) {
        console.error('Error deleting message:', error);
        alert('Failed to delete message. Please try again later.');
      }
    }
  } else {
    // Non-creator can only hide locally
    if (window.confirm('This will hide the message from your view only. The message will still be visible to others.')) {
      console.log('Hiding message:', message.id);
      
      // Add to hidden messages
      setHiddenMessages(prev => {
        const newHidden = new Set([...prev, message.id]);
        console.log('Updated hidden messages:', [...newHidden]);
        return newHidden;
      });
      
      // Close popup and clear jump dot if needed
      if (activePopup && activePopup.message.id === message.id) {
        closePopup();
      }
      
      if (jumpDot && jumpDot.message && jumpDot.message.id === message.id) {
        setJumpDot(null);
      }
      
      alert('Message hidden from your view.');
    }
  }
};

// Check if user is creator of a message
const isMessageCreator = (message) => {
  const sessionId = localStorage.getItem('tempUserId');
  return message.user_session_id === sessionId;
};



  // useEffect(() => {
  //   if (jumpDot) {
  //     console.log('Jump dot state updated:', jumpDot);
      
  //     // Force repaint of the grid background to ensure jump dot is visible
  //     if (gridBackgroundRef.current) {
  //       const current = gridBackgroundRef.current.style.display;
  //       gridBackgroundRef.current.style.display = 'none';
  //       // Force reflow (add a dummy variable to use the expression result)
  //       const reflow = gridBackgroundRef.current.offsetHeight;
  //       gridBackgroundRef.current.style.display = current;
  //     }
  //   }
  // }, [jumpDot]);
  
useEffect(() => {
  const checkMobileView = () => {
    setIsMobileView(window.innerWidth <= 768);
  };
  
  checkMobileView();
  window.addEventListener('resize', checkMobileView);
  
  const hasVisitedBefore = localStorage.getItem('hasVisitedMessageMap');
  if (!hasVisitedBefore && isMobileView) {
    setShowMobileDragHint(true);
    setTimeout(() => setShowMobileDragHint(false), 3000);
    localStorage.setItem('hasVisitedMessageMap', 'true');
  }
  
  // Load hidden messages FIRST before doing anything else
  const storedHiddenMessages = localStorage.getItem('hiddenMessages');
  if (storedHiddenMessages) {
    try {
      const hiddenArray = JSON.parse(storedHiddenMessages);
      const hiddenSet = new Set(hiddenArray);
      setHiddenMessages(hiddenSet);
      console.log('Loaded hidden messages from localStorage:', hiddenArray);
    } catch (e) {
      console.error('Error loading hidden messages:', e);
      // If there's an error, clear the corrupted data
      localStorage.removeItem('hiddenMessages');
      setHiddenMessages(new Set());
    }
  }

  // Load user session ID
  const sessionId = localStorage.getItem('tempUserId');
  if (sessionId) {
    setUserSessionId(sessionId);
  }
  
  const storedToken = localStorage.getItem('authToken');
  if (storedToken) {
    try {
      const tokenPayload = JSON.parse(atob(storedToken.split('.')[1]));
      const username = tokenPayload['cognito:username'] || tokenPayload.username || 'User';
      setUsername(username);
      setIsLoggedIn(true);
      
      const storedTokens = localStorage.getItem('userTokens');
      if (storedTokens) {
        setUserTokens(parseFloat(storedTokens));
      }
    } catch (e) {
      console.error('Error parsing stored token:', e);
      localStorage.removeItem('authToken');
    }
  }
  
  // Fetch messages AFTER loading hidden messages
  fetchMessages();
  
  return () => {
    window.removeEventListener('resize', checkMobileView);
  };
}, []);
  
  const isDraggingRef = useRef(false);
  const startDragPosRef = useRef({ x: 0, y: 0 });
  const mapPositionRef = useRef({ x: 0, y: 0 });
  
  const showDirectionalIndicator = (dx, dy) => {
    let direction = '';
    const threshold = 5;
    
    if (Math.abs(dx) > threshold || Math.abs(dy) > threshold) {
      if (Math.abs(dx) > Math.abs(dy)) {
        direction = dx > 0 ? 'west' : 'east';
      } else {
        direction = dy > 0 ? 'north' : 'south';
      }
      
      setGridMoveIndicator({ active: true, direction: direction });
      
      if (gridMoveTimeout.current) clearTimeout(gridMoveTimeout.current);
      gridMoveTimeout.current = setTimeout(() => {
        setGridMoveIndicator({ active: false, direction: '' });
      }, 1000);
      
      updateActiveCells(direction);
    }
  };
  
  const updateActiveCells = (direction) => {
    activeCellsRef.current.forEach(cell => {
      if (cell && cell.parentNode) {
        cell.parentNode.removeChild(cell);
      }
    });
    
    activeCellsRef.current = [];
    
    const gridCells = document.querySelector('.grid-cells');
    if (!gridCells) return;
    
    const cellCount = 5;
    
    for (let i = 1; i <= cellCount; i++) {
      const cell = document.createElement('div');
      cell.className = 'grid-cell active';
      
      const offset = i * 20;
      
      switch (direction) {
        case 'north':
          cell.style.top = `calc(50% - ${offset + 10}px)`;
          cell.style.left = 'calc(50% - 10px)';
          break;
        case 'south':
          cell.style.top = `calc(50% + ${offset - 10}px)`;
          cell.style.left = 'calc(50% - 10px)';
          break;
        case 'east':
          cell.style.top = 'calc(50% - 10px)';
          cell.style.left = `calc(50% + ${offset - 10}px)`;
          break;
        case 'west':
          cell.style.top = 'calc(50% - 10px)';
          cell.style.left = `calc(50% - ${offset + 10}px)`;
          break;
      }
      
      gridCells.appendChild(cell);
      activeCellsRef.current.push(cell);
    }
    
    if (cellUpdateInterval.current) clearTimeout(cellUpdateInterval.current);
    cellUpdateInterval.current = setTimeout(() => {
      activeCellsRef.current.forEach(cell => {
        if (cell && cell.parentNode) {
          cell.parentNode.removeChild(cell);
        }
      });
      activeCellsRef.current = [];
    }, 2000);
  };
  
  const updateGridTransform = () => {
    if (gridBackgroundRef.current) {
      gridBackgroundRef.current.style.transform = 
        `translate(${mapPositionRef.current.x}px, ${mapPositionRef.current.y}px) scale(${zoomLevel})`;
    }
  };
  
  const handleMouseDown = (e) => {
    // Don't start dragging if the event originated from an interactive element
    if (isInteractiveElement(e.target)) {
      return;
    }

    if (isPlacingMessage) return;

    isDraggingRef.current = true;
    dragCountRef.current = 0;
    startDragPosRef.current = { x: e.clientX, y: e.clientY };

    if (mapRef.current) {
      mapRef.current.style.cursor = 'grabbing';
    }

    if (focalMessage) {
      setIsDraggingFromMessage(true);
      lastMessageCoordinatesRef.current = {
        x: focalMessage.x_coordinate,
        y: focalMessage.y_coordinate,
        id: focalMessage.id
      };
    }
  };

  const calculateGridCoordinates = (clientX, clientY) => {
    if (!mapRef.current) return { gridX: GRID_CENTER, gridY: GRID_CENTER };
    
    const rect = mapRef.current.getBoundingClientRect();
    
    const normalizedX = mapPositionRef.current.x / CELL_SIZE;
    const normalizedY = mapPositionRef.current.y / CELL_SIZE;
    
    const pointerRelX = (clientX - rect.left) / rect.width;
    const pointerRelY = (rect.height - (clientY - rect.top)) / rect.height;
    
    const billionGridX = Math.floor(GRID_CENTER + normalizedX + ((pointerRelX - 0.5) * VISIBLE_GRID_SIZE));
    const billionGridY = Math.floor(GRID_CENTER + normalizedY + ((pointerRelY - 0.5) * VISIBLE_GRID_SIZE));
    
    return { 
      gridX: billionGridX, 
      gridY: billionGridY 
    };
  };

  const handleMouseMove = (e) => {
    // Don't continue dragging if currently over an interactive element
    if (isDraggingRef.current && isInteractiveElement(e.target)) {
      return;
    }
    
    if (isDraggingRef.current) {
      const dx = e.clientX - startDragPosRef.current.x;
      const dy = e.clientY - startDragPosRef.current.y;
      
      dragCountRef.current++;
      
      if (isDraggingFromMessage && lastMessageCoordinatesRef.current) {
        if (dragCountRef.current < 5) {
          setCoordinates({
            gridX: parseInt(lastMessageCoordinatesRef.current.x),
            gridY: parseInt(lastMessageCoordinatesRef.current.y),
            isMessageCoordinates: true,
            messageId: lastMessageCoordinatesRef.current.id
          });
        } else {
          if (Math.abs(dx) > 5 || Math.abs(dy) > 5) {
            if (focalMessage) {
              setFocalMessage(null);
            }
            
            if (dragCountRef.current === 5) {
              setTimeout(() => {
                if (isDraggingRef.current) {
                  setIsDraggingFromMessage(false);
                }
              }, 100);
            }
            
            if (mapRef.current && dragCountRef.current > 10) {
              const coords = calculateGridCoordinates(e.clientX, e.clientY);
              setCoordinates(coords);
            }
          }
        }
      } else if (!isDraggingFromMessage && !focalMessage) {
        if (mapRef.current) {
          const coords = calculateGridCoordinates(e.clientX, e.clientY);
          setCoordinates(coords);
        }
      }
      
      showDirectionalIndicator(dx, dy);
      
      mapPositionRef.current.x += dx;
      mapPositionRef.current.y += dy;
      
      updateGridTransform();
      
      startDragPosRef.current = { x: e.clientX, y: e.clientY };
      return;
    }
    
    if (!focalMessage && !isPlacingMessage && !isDraggingFromMessage) {
      if (mapRef.current && !isInteractiveElement(e.target)) {
        const coords = calculateGridCoordinates(e.clientX, e.clientY);
        setCoordinates(coords);
      }
    }
    
    if (isPlacingMessage && mapRef.current && !isInteractiveElement(e.target)) {
      const coords = calculateGridCoordinates(e.clientX, e.clientY);
      
      document.getElementById('x-coordinate').value = coords.gridX;
      document.getElementById('y-coordinate').value = coords.gridY;
    }
  };
  
// Modify handleTouchStart to allow placement touches
const handleTouchStart = (e) => {
  const touch = e.touches[0];
  touchStartRef.current = { x: touch.clientX, y: touch.clientY };
  lastTouchRef.current = { x: touch.clientX, y: touch.clientY };
  touchTimeRef.current = Date.now();
  isTouchDraggingRef.current = false;
};

// Update handleTouchMove to ensure dragging works properly
const handleTouchMove = (e) => {
  if (isPlacingMessage) {
    // Handle in placement mode
    const touch = e.touches[0];
    if (mapRef.current) {
      const coords = calculateGridCoordinates(touch.clientX, touch.clientY);
      setCoordinates(coords);
    }
    return;
  }

  // Allow native scrolling inside popups and scrollable content
  const target = e.target;
  let el = target;
  while (el && el !== mapRef.current) {
    const cls = el.className || '';
    if (
      cls.includes('message-popup') ||
      cls.includes('decoded-message-text') ||
      cls.includes('popup-overlay') ||
      cls.includes('decode-section') ||
      el.tagName === 'INPUT' ||
      el.tagName === 'TEXTAREA'
    ) {
      // Don't preventDefault - let the popup/content scroll naturally
      return;
    }
    el = el.parentElement;
  }

  // Prevent default to avoid browser scrolling while dragging the map
  e.preventDefault();
  
  const touch = e.touches[0];
  const dx = touch.clientX - lastTouchRef.current.x;
  const dy = touch.clientY - lastTouchRef.current.y;
  
  // Lower the threshold for considering a touch as dragging
  const totalDx = touch.clientX - touchStartRef.current.x;
  const totalDy = touch.clientY - touchStartRef.current.y;
  
  if (Math.abs(totalDx) > 5 || Math.abs(totalDy) > 5) {
    isTouchDraggingRef.current = true;

    if (!hasDragged) {
      setHasDragged(true);
    }
  }
  
  // Always apply the drag if there's movement, don't check isTouchDraggingRef
  // This ensures even small movements update the map position
  if (Math.abs(dx) > 0 || Math.abs(dy) > 0) {
    showDirectionalIndicator(dx, dy);
    
    mapPositionRef.current.x += dx;
    mapPositionRef.current.y += dy;
    
    updateGridTransform();
    
    if (mapRef.current) {
      const coords = calculateGridCoordinates(touch.clientX, touch.clientY);
      setCoordinates(coords);
    }
  }
  
  lastTouchRef.current = { x: touch.clientX, y: touch.clientY };
};

// Ensure touch events are properly registered on the map
useEffect(() => {
  if (mapRef.current) {
    // Fix for mobile touch events - add passive: false
    mapRef.current.addEventListener('touchmove', handleTouchMove, { passive: false });
    
    return () => {
      if (mapRef.current) {
        mapRef.current.removeEventListener('touchmove', handleTouchMove);
      }
    };
  }
}, [mapRef.current]); // Dependencies array to only run once when map is created

// Modify handleTouchEnd to properly handle placement
const handleTouchEnd = (e) => {
  const touchDuration = Date.now() - touchTimeRef.current;
  
  if (!isTouchDraggingRef.current && touchDuration < 300) {
    if (isPlacingMessage && mapRef.current) {
      const touch = e.changedTouches[0];
      const coords = calculateGridCoordinates(touch.clientX, touch.clientY);
      
      document.getElementById('x-coordinate').value = coords.gridX;
      document.getElementById('y-coordinate').value = coords.gridY;
      
      // Only set isPlacingMessage to false if it was a short tap
      // This allows the user to actually place a message
      setIsPlacingMessage(false);
      mapRef.current.style.cursor = 'grab';
      
      // Show visual feedback that coordinates were set
      setJumpSuccessMessage(`Coordinates set: ${coords.gridX},${coords.gridY}`);
      
      // Switch to controls tab so user can finish message
      if (isMobileView) {
        switchTab('controls');
      }
    }
  }
  
  isTouchDraggingRef.current = false;
};

  const handleMouseUp = () => {
    isDraggingRef.current = false;
    dragCountRef.current = 0;
    
    if (mapRef.current) {
      mapRef.current.style.cursor = isPlacingMessage ? 'crosshair' : 'grab';
    }
    
    if (isDraggingFromMessage) {
      setIsDraggingFromMessage(false);
    }
    
    if (!focalMessage) {
      lastMessageCoordinatesRef.current = null;
    }
  };
  
  const handleZoom = (direction) => {
    setZoomLevel(prevZoom => {
      const newZoom = direction === 'in' 
        ? Math.min(prevZoom + 0.1, 2) 
        : Math.max(prevZoom - 0.1, 0.5);
      
      return newZoom;
    });
  };
  
  useEffect(() => {
    updateGridTransform();
  }, [zoomLevel]);
  
  useEffect(() => {
    document.addEventListener('mouseup', handleMouseUp);
    return () => {
      document.removeEventListener('mouseup', handleMouseUp);
    };
  }, []);
  
  useEffect(() => {
    return () => {
      if (gridMoveTimeout.current) {
        clearTimeout(gridMoveTimeout.current);
      }
      if (cellUpdateInterval.current) {
        clearTimeout(cellUpdateInterval.current);
      }
    };
  }, []);
  
  const handleMapClick = (e) => {
    if (!isPlacingMessage || !mapRef.current) return;
    
    if (focusedOnMessage) {
      setFocusedOnMessage(false);
    }
    
    const coords = calculateGridCoordinates(e.clientX, e.clientY);
    
    document.getElementById('x-coordinate').value = coords.gridX;
    document.getElementById('y-coordinate').value = coords.gridY;
    
    setIsPlacingMessage(false);
    mapRef.current.style.cursor = 'grab';
  };

  const togglePlacementMode = () => {
    const newState = !isPlacingMessage;
    setIsPlacingMessage(newState);
    
    if (mapRef.current) {
      mapRef.current.style.cursor = newState ? 'crosshair' : 'grab';
    }
  };
  
  const generateRandomCoordinates = () => {
    const randX = Math.floor(Math.random() * GRID_SIZE);
    const randY = Math.floor(Math.random() * GRID_SIZE);
    
    document.getElementById('x-coordinate').value = randX;
    document.getElementById('y-coordinate').value = randY;
  };
  
  const handleLogin = async () => {
    if (!paymentId.trim()) {
      setLoginStatus('Please enter your Login ID');
      setStatusColor('#d32f2f');
      return;
    }
    
    setLoginStatus('Logging in...');
    setStatusColor('#000');
    
    try {
      const response = await fetch(`${apiUrl}/login`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          payment_id: paymentId
        })
      });
      
      const data = await response.json();
      
      if (response.ok && data.id_token) {
        localStorage.setItem('authToken', data.id_token);
        setLoginStatus('Login successful!');
        setStatusColor('#4CAF50');
        
        setIsLoggedIn(true);
        
        try {
          const tokenPayload = JSON.parse(atob(data.id_token.split('.')[1]));
          const username = tokenPayload['cognito:username'] || tokenPayload.username || 'User';
          setUsername(username);
        } catch (e) {
          setUsername('Authenticated User');
        }
        
        if (data.tokens) {
          localStorage.setItem('userTokens', data.tokens.toString());
          setUserTokens(data.tokens);
        }
        
        if (data.temp_user_id) {
          localStorage.setItem('tempUserId', data.temp_user_id);
        }
        if (data.isPremium === true) {
          localStorage.setItem('isPremiumUser', true);
        } 
        fetchMessages();
      } else {
        setLoginStatus(data.message || 'Login failed. Please check your Login ID.');
        setStatusColor('#d32f2f');
      }
    } catch (error) {
      console.error('Login error:', error);
      setLoginStatus('Connection error. Please try again.');
      setStatusColor('#d32f2f');
    }
  };
  
  const handleLogout = () => {
    localStorage.removeItem('authToken');
    localStorage.removeItem('userTokens');
    localStorage.removeItem('tempUserId');
    setIsLoggedIn(false);
    setUsername('');
    setPaymentId('');
    setUserTokens(0);
    setLoginStatus('Logged out successfully');
    setStatusColor('#4CAF50');
    
    fetchMessages();
  };
  
  const fetchMessages = async () => {
    try {
      const response = await fetch(`${apiUrl}/messages`, {
        method: 'GET'
      });
      
      const data = await response.json();
      
      if (response.ok) {
        setMessages(data.messages || []);
      } else {
        console.error('Error fetching messages:', data.error);
      }
    } catch (error) {
      console.error('Error connecting to server:', error);
    }
  };
  
  const startRecording = async () => {
    try {
      const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
      const recorder = new MediaRecorder(stream);
      audioRecorderRef.current = recorder;
      
      const chunks = [];
      recorder.addEventListener('dataavailable', event => {
        chunks.push(event.data);
      });
      
      recorder.addEventListener('stop', () => {
        setRecordingStatus('Recording saved!');
        setIsRecording(false);
        
        if (recordingIntervalRef.current) {
          clearInterval(recordingIntervalRef.current);
          recordingIntervalRef.current = null;
        }
        
        setAudioChunks(chunks);
        
        const audioBlob = new Blob(chunks, { type: 'audio/mp3' });
        const audioUrl = URL.createObjectURL(audioBlob);
        audioPreviewRef.current = audioUrl;
      });
      
      recorder.start();
      setIsRecording(true);
      recordingStartTimeRef.current = Date.now();
      
      setRecordingStatus('Recording...');
      setRecordingTime('0:00');
      
      recordingIntervalRef.current = setInterval(() => {
        const elapsedMs = Date.now() - recordingStartTimeRef.current;
        const minutes = Math.floor(elapsedMs / 60000);
        const seconds = Math.floor((elapsedMs % 60000) / 1000);
        setRecordingTime(`${minutes}:${seconds.toString().padStart(2, '0')}`);
        
        if (elapsedMs >= MAX_RECORDING_TIME) {
          if (audioRecorderRef.current && isRecording) {
            audioRecorderRef.current.stop();
            setRecordingStatus('Maximum recording time reached (5 minutes)');
          }
        }
      }, 1000);
      
    } catch (error) {
      console.error('Error accessing microphone:', error);
      setRecordingStatus('Error: Could not access microphone');
    }
  };
  
  const stopRecording = () => {
    if (audioRecorderRef.current && isRecording) {
      audioRecorderRef.current.stop();
    }
  };
  const copyToClipboard = async (text, buttonElement = null) => {
    // Get the button element if not passed as parameter
    const button = buttonElement || document.activeElement;
    
    try {
      // For modern browsers with clipboard API
      if (navigator.clipboard && window.isSecureContext) {
        await navigator.clipboard.writeText(text);
        showCopySuccess(button);
        return;
      }
      
      // Fallback for older browsers or non-secure contexts
      throw new Error('Clipboard API not available');
      
    } catch (err) {
      console.log('Using fallback copy method:', err.message);
      
      // Enhanced fallback for Safari and older browsers
      try {
        await safariCompatibleCopy(text);
        showCopySuccess(button);
      } catch (fallbackErr) {
        console.error('All copy methods failed:', fallbackErr);
        
        // Final fallback - show the text for manual copying
        if (window.confirm(`Copy failed. Click OK to see the text to copy manually:\n\n${text}`)) {
          // User clicked OK, they've seen the text
        }
      }
    }
  };
  
  const safariCompatibleCopy = (text) => {
    return new Promise((resolve, reject) => {
      // Create a text area element
      const textArea = document.createElement('textarea');
      
      // Configure the text area to be invisible and non-disruptive
      textArea.value = text;
      textArea.style.position = 'fixed';
      textArea.style.left = '-9999px';
      textArea.style.top = '-9999px';
      textArea.style.opacity = '0';
      textArea.style.pointerEvents = 'none';
      textArea.style.zIndex = '-1';
      textArea.setAttribute('readonly', '');
      textArea.setAttribute('aria-hidden', 'true');
      
      try {
        // Add to DOM
        document.body.appendChild(textArea);
        
        // Focus and select (required for Safari)
        textArea.focus();
        textArea.select();
        textArea.setSelectionRange(0, textArea.value.length);
        
        // For iOS Safari, we need to handle this differently
        if (navigator.userAgent.match(/ipad|iphone/i)) {
          const range = document.createRange();
          range.selectNodeContents(textArea);
          const selection = window.getSelection();
          selection.removeAllRanges();
          selection.addRange(range);
          textArea.setSelectionRange(0, 999999);
        }
        
        // Execute copy command
        const successful = document.execCommand('copy');
        
        if (successful) {
          resolve();
        } else {
          reject(new Error('execCommand copy failed'));
        }
        
      } catch (err) {
        reject(err);
      } finally {
        // Clean up - remove the text area
        try {
          if (textArea.parentNode) {
            document.body.removeChild(textArea);
          }
        } catch (cleanupErr) {
          console.warn('Cleanup failed:', cleanupErr);
        }
      }
    });
  };
  const showCopySuccess = (button) => {
    // Handle button feedback
    if (button && button.tagName === 'BUTTON') {
      const originalText = button.textContent;
      const originalClass = button.className;
      
      button.textContent = "Copied!";
      button.classList.add('copied');
      button.disabled = true;
      
      setTimeout(() => {
        try {
          button.textContent = originalText;
          button.className = originalClass;
          button.disabled = false;
        } catch (err) {
          console.warn('Button reset failed:', err);
        }
      }, 2000);
    }
    
    // Show mobile toast if needed
    if (isMobileView) {
      showToast('Copied to clipboard!');
    }
  };    

  
  const showToast = (message) => {
    // Remove any existing toasts first
    const existingToasts = document.querySelectorAll('.copy-toast');
    existingToasts.forEach(toast => {
      if (toast.parentNode) {
        toast.parentNode.removeChild(toast);
      }
    });
    
    const toast = document.createElement('div');
    toast.className = 'copy-toast';
    toast.textContent = message;
    toast.style.cssText = `
      position: fixed;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      background: rgba(0, 0, 0, 0.8);
      color: white;
      padding: 12px 24px;
      border-radius: 6px;
      z-index: 10000;
      font-size: 14px;
      opacity: 0;
      transition: opacity 0.3s ease;
      pointer-events: none;
    `;
    
    document.body.appendChild(toast);
    
    // Trigger animation
    requestAnimationFrame(() => {
      toast.style.opacity = '1';
    });
    
    // Remove toast
    setTimeout(() => {
      toast.style.opacity = '0';
      setTimeout(() => {
        if (toast.parentNode) {
          document.body.removeChild(toast);
        }
      }, 300);
    }, 2000);
  };

  const copyToClipboardz = (text) => {
    navigator.clipboard.writeText(text)
      .then(() => {
        // Find which button was clicked
        const button = document.activeElement;
        if (button) {
          // Add visual feedback to the button
          const originalText = button.textContent;
          button.textContent = "Copied!";
          button.classList.add('copied');
          
          setTimeout(() => {
            button.textContent = originalText;
            button.classList.remove('copied');
          }, 2000);
        }
        
        // Show a brief toast message on mobile
        if (isMobileView) {
          const toast = document.createElement('div');
          toast.className = 'copy-toast';
          toast.textContent = 'Copied to clipboard!';
          document.body.appendChild(toast);
          
          setTimeout(() => {
            toast.classList.add('show');
          }, 10);
          
          setTimeout(() => {
            toast.classList.remove('show');
            setTimeout(() => {
              document.body.removeChild(toast);
            }, 300);
          }, 2000);
        }
      })
      .catch(err => {
        console.error('Failed to copy: ', err);
        alert('Failed to copy to clipboard');
      });
  };
  useEffect(() => {
    let timerInterval;
    
    if (encodingKeyNotification) {
      timerInterval = setInterval(() => {
        const secondsLeft = Math.ceil(60 - (Date.now() - encodingKeyNotification.timestamp) / 1000);
        
        const timerElement = document.querySelector('.notification-timer');
        if (timerElement) {
          timerElement.textContent = `This notification will close in ${secondsLeft > 0 ? secondsLeft : 0} seconds`;
        }
        
        if (secondsLeft <= 0) {
          clearInterval(timerInterval);
        }
      }, 1000);
    }
    
    return () => {
      if (timerInterval) {
        clearInterval(timerInterval);
      }
    };
  }, [encodingKeyNotification]);
  
  useEffect(() => {
    return () => {
      if (notificationTimeout) {
        clearTimeout(notificationTimeout);
      }
    };
  }, [notificationTimeout]);
  
  useEffect(() => {
    let popupTimer;
    
    if (activePopup) {
      popupTimer = setTimeout(() => {
        closePopup();
      }, 60000);
    }
    
    return () => {
      if (popupTimer) {
        clearTimeout(popupTimer);
      }
    };
  }, [activePopup]);
  
  const submitMessage = async () => {
    const authToken = localStorage.getItem('authToken');
    if (!authToken) {
      alert('Please login to perform this action');
      return;
    }
    
    const xCoordinate = parseInt(document.getElementById('x-coordinate').value);
    const yCoordinate = parseInt(document.getElementById('y-coordinate').value);
    
    if (isNaN(xCoordinate) || isNaN(yCoordinate) || 
        xCoordinate < 0 || xCoordinate > GRID_SIZE || 
        yCoordinate < 0 || yCoordinate > GRID_SIZE) {
      alert(`Please provide valid grid coordinates (0 to ${GRID_SIZE})`);
      return;
    }
    
    if (isNaN(expirationTime) || expirationTime < 2 || expirationTime > 60) {
      alert('Expiration time must be between 2 and 60 minutes');
      return;
    }
    
    const requestData = {
      content_type: messageType,
      expiration_time: expirationTime,
      x_coordinate: xCoordinate,
      y_coordinate: yCoordinate
    };
    
    if (messageType === 'text') {
      if (!messageText.trim()) {
        alert('Please enter a message');
        return;
      }
      
      requestData.text = messageText;
    } else {
      if (!audioChunks.length) {
        alert('Please record an audio message');
        return;
      }
      
      const audioBlob = new Blob(audioChunks, { type: 'audio/mp3' });
      const reader = new FileReader();
      
      reader.readAsDataURL(audioBlob);
      reader.onloadend = function() {
        const base64Audio = reader.result.split(',')[1];
        requestData.audio = base64Audio;
        sendMessageToApi(requestData, authToken);
      };
      return;
    }
    
    sendMessageToApi(requestData, authToken);
  };
  
  const sendMessageToApi = async (requestData, authToken) => {
    try {
      const response = await fetch(`${apiUrl}/messages`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': authToken
        },
        body: JSON.stringify(requestData)
      });
      
      const data = await response.json();
      
      if (response.ok) {
        if (data.tokens !== undefined) {
          setUserTokens(data.tokens);
          localStorage.setItem('userTokens', data.tokens.toString());
        }
        
        const encodingKey = data.encryption_key || 'Not available';
        
        if (notificationTimeout) {
          clearTimeout(notificationTimeout);
        }
        
        setEncodingKeyNotification({
          key: encodingKey,
          coordinates: requestData.x_coordinate +','+ requestData.y_coordinate,
          message: 'Your message has been cast into the void! You have 60 seconds to copy your coordinates and access code. After this information will not be available anymore:',
          timestamp: Date.now()
        });
        
        const timeout = setTimeout(() => {
          setEncodingKeyNotification(null);
        }, 60000);
        
        setNotificationTimeout(timeout);
        
        setMessageText('');
        document.getElementById('x-coordinate').value = '';
        document.getElementById('y-coordinate').value = '';
        setAudioChunks([]);
        audioPreviewRef.current = null;
        
        fetchMessages();
      } else {
        if (response.status === 403 && data.error === 'Insufficient tokens') {
          alert(`${data.message || 'You do not have enough tokens for this action.'}`);
        } else {
          if (response.status === 401) {
            handleLogout();
          }
          alert(`Error: ${data.error || 'Failed to post message'}`);
          
        }
      }
    } catch (error) {
      console.error('Error posting message:', error);
      alert('Failed to connect to the server. Please try again later.');
    }
  };
  
  // const closePopup = useCallback(() => {
  //   setActivePopup(null);
  //   const overlay = document.querySelector('.popup-overlay');
  //   if (overlay && overlay.parentNode) {
  //     overlay.parentNode.removeChild(overlay);
  //   }
  // }, []);
  // In the closePopup function, modify it to remember the last active message
  // const closePopup = useCallback(() => {
  //   if (activePopup && activePopup.message) {
  //     // Keep the dot visible when popup closes
  //     const msgX = parseInt(activePopup.message.x_coordinate);
  //     const msgY = parseInt(activePopup.message.y_coordinate);
      
  //     // Create a persistent dot that stays visible
  //     setJumpDot({
  //       gridX: msgX,
  //       gridY: msgY,
  //       isMessage: true,
  //       message: activePopup.message,
  //       fromClosedPopup: true,  // Flag to identify this is from a closed popup
  //       key: Date.now()
  //     });
      
  //     // Center the view on the message dot
  //     if (isMobileView) {
  //       // Keep the map centered on the message position
  //       const messagePosition = getSmartPosition(msgX, msgY, messages);
  //       // Ensure the map stays centered on this point
  //       setFocalMessage(activePopup.message);
  //     }
  //   }
    
  //   setActivePopup(null);
  //   const overlay = document.querySelector('.popup-overlay');
  //   if (overlay && overlay.parentNode) {
  //     overlay.parentNode.removeChild(overlay);
  //   }
  // }, [isMobileView]);
const closePopup = useCallback(() => {
  setActivePopup(null);
  const overlay = document.querySelector('.popup-overlay');
  if (overlay && overlay.parentNode) {
    overlay.parentNode.removeChild(overlay);
  }
  
  // FIXED: Don't create new dots or clear existing ones when closing popup
  // Just let the existing jump dot remain visible
}, []);
const additionalMobileStyles = `
/* Ensure jump dots remain visible and interactive after popup closes */
.jump-dot {
  position: absolute !important;
  z-index: 1500 !important;
  pointer-events: auto !important;
  opacity: 1 !important;
  visibility: visible !important;
}

/* Mobile specific jump dot styling */
@media (max-width: 768px) {
  .jump-dot {
    width: 36px !important;
    height: 36px !important;
    border: 4px solid white !important;
    z-index: 1500 !important;
    pointer-events: auto !important;
  }
  
  .jump-dot.from-message-list {
    background-color: #00BFFF !important;
    box-shadow: 0 0 25px rgba(0, 191, 255, 0.8) !important;
  }
  
  .jump-dot.from-auto-load {
    background-color: #32CD32 !important;
    box-shadow: 0 0 25px rgba(50, 205, 50, 0.8) !important;
  }
  
  /* Ensure dots stay clickable even after popup interaction */
  .jump-dot:after {
    content: "";
    position: absolute;
    top: -10px;
    left: -10px;
    right: -10px;
    bottom: -10px;
    background: transparent;
    z-index: 1501;
  }
}

/* Center dot pulse animation */
@keyframes centerDotPulse {
  0%, 100% {
    transform: translate(-50%, -50%) scale(1);
    opacity: 1;
  }
  50% {
    transform: translate(-50%, -50%) scale(1.2);
    opacity: 0.9;
  }
}
`;
  useEffect(() => {
    if (!messages.length ) return;
  
    const checkExpiredMessages = () => {
      const now = Math.floor(Date.now() / 1000);
      const activeMessages = messages.filter(message => message.ttl > now);
  
      if (activeMessages.length !== messages.length) {
        setMessages(activeMessages);
        
        // Close popup if the active message has expired
        if (activePopup && activePopup.message.ttl <= now) {
          closePopup();
        }
        
        // Clear jumpDot if it represents an expired message
        if (jumpDot && jumpDot.isMessage && jumpDot.message && jumpDot.message.ttl <= now) {
          setJumpDot(null);
        }
      }
    };
  
    // Check immediately
    checkExpiredMessages();
  
    // Set up interval to check every 30 seconds
    const expirationInterval = setInterval(checkExpiredMessages, 30000);
  
    return () => {
      clearInterval(expirationInterval);
    };
  }, [messages, jumpDot, activePopup, closePopup]);
 // Update the showMessagePopup function to handle mobile dialog pointing
const showMessagePopup = (message, x, y) => {
  setActivePopup({
    message,
    x,
    y
  });
   if (isMobileView) {
    const existingOverlay = document.querySelector('.popup-overlay');
    if (existingOverlay && existingOverlay.parentNode) {
      existingOverlay.parentNode.removeChild(existingOverlay);
    }
    
    const overlay = document.createElement('div');
    overlay.className = 'popup-overlay';
    overlay.addEventListener('click', closePopup);
    document.body.appendChild(overlay);
  }
  // if (isMobileView) {
  //   const existingOverlay = document.querySelector('.popup-overlay');
  //   if (existingOverlay && existingOverlay.parentNode) {
  //     existingOverlay.parentNode.removeChild(existingOverlay);
  //   }
    
  //   const overlay = document.createElement('div');
  //   overlay.className = 'popup-overlay';
  //   overlay.addEventListener('click', closePopup);
  //   document.body.appendChild(overlay);
    
  //   // Create a visual indicator pointing to the dot location
  //   setTimeout(() => {
  //     // Highlight the dot by creating a pulsing element
  //     const messagePosition = getSmartPosition(
  //       parseInt(message.x_coordinate),
  //       parseInt(message.y_coordinate),
  //       messages
  //     );
      
  //     setJumpDot({
  //       gridX: parseInt(message.x_coordinate),
  //       gridY: parseInt(message.y_coordinate),
  //       isMessage: true,
  //       message: message,
  //       fromPopup: true,  // Flag to identify this is from popup
  //       key: Date.now()
  //     });
      
  //     const popup = document.querySelector('.message-popup');
  //     if (popup) {
  //       // Add a class to make popup point downward
  //       popup.classList.add('mobile-popup');
  //       popup.scrollIntoView({ behavior: 'smooth', block: 'center' });
  //     }
  //   }, 100);
  // }
};

  // FIXED: Smart coordinate conversion that handles clustered coordinates
  const convertToGridPercentage = (gridX, gridY) => {
    // Ensure coordinates are numbers
    const x = Number(gridX);
    const y = Number(gridY);
    
    // Calculate basic percentages
    const relX = (x / GRID_SIZE) * 100;
    const relY = (y / GRID_SIZE) * 100;
    
    return { x: relX, y: relY };
  };

 const getSmartPosition = (gridX, gridY, allMessages, forceSpread = false) => {
  const x = Number(gridX);
  const y = Number(gridY);
  
  // CRITICAL FIX: Don't spread on mobile view or for individual jump dots
  // Only spread when we have many messages clustered together on desktop
  if (isMobileView || forceSpread === false) {
    // Use simple percentage positioning for mobile and jump dots
    return { 
      x: (x / GRID_SIZE) * 100, 
      y: (y / GRID_SIZE) * 100, 
      isSpread: false 
    };
  }
  
  // Get coordinate ranges for all messages
  const allX = allMessages.map(m => Number(m.x_coordinate));
  const allY = allMessages.map(m => Number(m.y_coordinate));
  
  // Add current coordinates to the analysis
  allX.push(x);
  allY.push(y);
  
  const minX = Math.min(...allX);
  const maxX = Math.max(...allX);
  const minY = Math.min(...allY);
  const maxY = Math.max(...allY);
  
  const rangeX = maxX - minX;
  const rangeY = maxY - minY;
  
  // Calculate what percentage of the total grid this range covers
  const gridCoverageX = (rangeX / GRID_SIZE) * 100;
  const gridCoverageY = (rangeY / GRID_SIZE) * 100;
  
  // Only spread if coordinates are very clustered AND we have many messages
  // AND forceSpread is explicitly true
  if (forceSpread && allMessages.length > 5 && gridCoverageX < 5 && gridCoverageY < 5) {
    // Map the coordinates to a more visible area (20% to 80% of the map)
    const VISIBLE_MIN = 20;
    const VISIBLE_MAX = 80;
    const VISIBLE_RANGE = VISIBLE_MAX - VISIBLE_MIN;
    
    // Normalize coordinates within their range (0 to 1)
    const normalizedX = rangeX > 0 ? (x - minX) / rangeX : 0.5;
    const normalizedY = rangeY > 0 ? (y - minY) / rangeY : 0.5;
    
    // Map to visible area
    const visibleX = VISIBLE_MIN + (normalizedX * VISIBLE_RANGE);
    const visibleY = VISIBLE_MIN + (normalizedY * VISIBLE_RANGE);
    
    return { x: visibleX, y: visibleY, isSpread: true };
  }
  
  // Use normal positioning for well-distributed coordinates
  return { x: (x / GRID_SIZE) * 100, y: (y / GRID_SIZE) * 100, isSpread: false };
};


const renderMessages = () => {
  return filteredMessages.map((message, index) => {
    const x = Number(message.x_coordinate);
    const y = Number(message.y_coordinate);
    
    // CRITICAL FIX: Use simple positioning on mobile, only spread on desktop if needed
    const gridPos = isMobileView 
      ? convertToGridPercentage(x, y) 
      : getSmartPosition(x, y, filteredMessages, false); // Don't force spread by default
    
    // Skip rendering if this exact message is being shown as a jump dot
    if (jumpDot && jumpDot.isMessage && jumpDot.message && jumpDot.message.id === message.id) {
      return null;
    }
    
    return (
      <div
        key={message.id}
        className={`message-dot ${message.content_type} ${gridPos.isSpread ? 'spread-out' : ''}`}
        style={{
          position: 'absolute',
          left: `${gridPos.x}%`,
          top: `${gridPos.y}%`,
          transform: 'translate(-50%, -50%)',
          zIndex: 5,
          pointerEvents: 'none'
        }}
        title={`Message at (${x}, ${y})${gridPos.isSpread ? ' - Position adjusted for visibility' : ''}`}
      ></div>
    );
  });
};

const centerGridOnMessage = (message) => {
  setFocalMessage(message);
  
  const messageX = parseInt(message.x_coordinate);
  const messageY = parseInt(message.y_coordinate);
  
  // CRITICAL FIX: Use simple positioning on mobile
  const gridPos = isMobileView 
    ? convertToGridPercentage(messageX, messageY)
    : getSmartPosition(messageX, messageY, messages, true);
  
  const offsetX = gridPos.x - 50;
  const offsetY = gridPos.y - 50;
  
  mapPositionRef.current = { x: 0, y: 0 };
  
  if (gridBackgroundRef.current) {
    const gridRect = gridBackgroundRef.current.getBoundingClientRect();
    const offsetPxX = -offsetX / 100 * gridRect.width;
    const offsetPxY = -offsetY / 100 * gridRect.height;
    
    mapPositionRef.current.x = offsetPxX;
    mapPositionRef.current.y = offsetPxY;
    
    updateGridTransform();
    
    setCoordinates({ 
      gridX: messageX, 
      gridY: messageY,
      isMessageCoordinates: true
    });
  }
};
const jumpToCoordinate = async () => {
  let jumpX, jumpY, decodingKey = null;
  
  if (document.getElementById('jump-coordinates')) {
    const input = document.getElementById('jump-coordinates').value.trim();
    
    // Parse Omega Link format: omega://x=X&y=Y&key=KEY
    const omegaLinkMatch = input.match(/omega:\/\/x=(\d+)&y=(\d+)(?:&key=([^&\s]+))?/i);
    
    if (omegaLinkMatch) {
      jumpX = parseInt(omegaLinkMatch[1]);
      jumpY = parseInt(omegaLinkMatch[2]);
      decodingKey = omegaLinkMatch[3] || null;
    } else {
      // Fallback to legacy format: X,Y or X,Y,KEY
      let parts = input.split(',').map(val => val.trim());
      
      if (parts.length < 2) {
        setJumpError('Please enter format: omega://x=X&y=Y&key=K or X,Y,Key');
        setTimeout(() => setJumpError(''), 3000);
        return;
      }
      
      jumpX = parseInt(parts[0]);
      jumpY = parseInt(parts[1]);
      decodingKey = parts.length >= 3 ? parts.slice(2).join(',').trim() : null;
    }
  } else {
    const jumpXInput = document.getElementById('jump-x-coordinate');
    const jumpYInput = document.getElementById('jump-y-coordinate');
    const keyInput = document.getElementById('jump-key-coordinate');
    
    if (!jumpXInput || !jumpYInput) return;
    
    jumpX = parseInt(jumpXInput.value);
    jumpY = parseInt(jumpYInput.value);
    decodingKey = keyInput ? keyInput.value.trim() : null;
  }
  
  if (isNaN(jumpX) || isNaN(jumpY)) {
    setJumpError('Please enter valid grid coordinates');
    setTimeout(() => setJumpError(''), 3000);
    return;
  }
  
  if (jumpX < 0 || jumpX > GRID_SIZE || jumpY < 0 || jumpY > GRID_SIZE) {
    setJumpError(`Coordinates must be within the grid (0 to ${GRID_SIZE})`);
    setTimeout(() => setJumpError(''), 3000);
    return;
  }
  
  closePopup();
  setJumpDot(null);

  // Calculate the position for this dot on the grid
  const dotPos = convertToGridPercentage(jumpX, jumpY);

  setCoordinates({
    gridX: jumpX,
    gridY: jumpY
  });

  showJumpSuccessMessage(`Jumped to ${jumpX},${jumpY}`);

  setFocalMessage(null);
  setIsDraggingFromMessage(false);
  lastMessageCoordinatesRef.current = null;

  const centerGridOnDot = () => {
    const offsetX = dotPos.x - 50;
    const offsetY = dotPos.y - 50;

    if (gridBackgroundRef.current) {
      const gridRect = gridBackgroundRef.current.getBoundingClientRect();
      if (gridRect.width > 0 && gridRect.height > 0) {
        const offsetPxX = -offsetX / 100 * gridRect.width;
        const offsetPxY = -offsetY / 100 * gridRect.height;

        mapPositionRef.current.x = offsetPxX;
        mapPositionRef.current.y = offsetPxY;

        updateGridTransform();
      }
    }
  };

  centerGridOnDot();

  const existingMessage = messages.find(message =>
    parseInt(message.x_coordinate) === jumpX &&
    parseInt(message.y_coordinate) === jumpY
  );

  const jumpDotConfig = {
    gridX: jumpX,
    gridY: jumpY,
    isMessage: !!existingMessage,
    message: existingMessage || null,
    fromJump: true,
    key: Date.now()
  };

  setJumpDot(jumpDotConfig);

  if (isMobileView) {
    switchTab('map');
    setTimeout(centerGridOnDot, 150);
    setTimeout(centerGridOnDot, 350);
  }

  if (existingMessage) {
    console.log('Message found at coordinates');
    setFocalMessage(existingMessage);

    // Show popup at the dot's actual position after 3 second delay
    // (allows time for user to see the jump animation to dot location)
    setTimeout(() => {
      if (decodingKey) {
        showMessagePopup(existingMessage, dotPos.x, dotPos.y);
        setTimeout(() => {
          autoDecodeMessage(existingMessage.id, decodingKey);
        }, 300);
      } else {
        showMessagePopup(existingMessage, dotPos.x, dotPos.y);
      }
    }, 3000);
    return;
  }
  
  // No message found - still create jump dot
  console.log('Creating jump dot at:', jumpX, jumpY);
  setJumpDot({
    gridX: jumpX,
    gridY: jumpY,
    isMessage: false,
    message: null,
    key: Date.now()
  });
  
  setIsJumpAnimating(true);
  
  // Check API for message if logged in
  if (isLoggedIn) {
    try {
      const coordinateId = `${jumpX}_${jumpY}`;
      const authToken = localStorage.getItem('authToken');
      
      const response = await fetch(`${apiUrl}/messages/${coordinateId}`, {
        method: 'GET',
        headers: {
          'Authorization': authToken
        }
      });
      
      const data = await response.json();
      
      if (response.ok && data.message) {
        // Update jump dot with message info at actual grid position
        setJumpDot({
          gridX: jumpX,
          gridY: jumpY,
          isMessage: true,
          message: data.message,
          fromJump: true,
          key: Date.now()
        });

        setFocalMessage(data.message);

        // Show popup at the dot's actual position after 3 second delay
        const apiDotPos = convertToGridPercentage(jumpX, jumpY);
        setTimeout(() => {
          if (decodingKey) {
            showMessagePopup(data.message, apiDotPos.x, apiDotPos.y);
            setTimeout(() => {
              autoDecodeMessage(data.message.id, decodingKey);
            }, 300);
          } else {
            showMessagePopup(data.message, apiDotPos.x, apiDotPos.y);
          }
        }, 3000);

        if (isMobileView) {
          switchTab('map');
        }
      } else {
        console.log('No message found at coordinates');
        setTimeout(() => {
          setJumpDot(null);
          setIsJumpAnimating(false);
        }, 3000);
      }
    } catch (error) {
      console.error('Error checking for message:', error);
      setTimeout(() => {
        setJumpDot(null);
        setIsJumpAnimating(false);
      }, 3000);
    }
  } else {
    setTimeout(() => {
      setJumpDot(null);
      setIsJumpAnimating(false);
    }, 3000);
  }
};
const autoDecodeMessage = async (messageId, encodingKey) => {
  const authToken = localStorage.getItem('authToken');

  if (!authToken) {
    alert('Please login to decode messages');
    return;
  }

  setAutoDecodingIds(prev => new Set(prev).add(messageId));

  try {
    const response = await fetch(`${apiUrl}/messages/${messageId}?encryption_key=${encodingKey}`, {
      method: 'GET',
      headers: {
        'Authorization': authToken
      }
    });

    const data = await response.json();

    if (response.ok && data.message) {
      setDecodedMessages(prev => ({
        ...prev,
        [messageId]: {
          content_type: data.message.content_type,
          decoded_text: data.message.decoded_text || null,
          decoded_audio_base64: data.message.decoded_audio_base64 || null,
          timestamp: Date.now()
        }
      }));
    } else {
      setDecodedMessages(prev => ({
        ...prev,
        [messageId]: {
          error: data.error || 'Invalid access code',
          timestamp: Date.now()
        }
      }));
      console.error('Decode error:', data.error);
    }
  } catch (error) {
    console.error('Error auto-decoding message:', error);
    setDecodedMessages(prev => ({
      ...prev,
      [messageId]: {
        error: 'Failed to decode message',
        timestamp: Date.now()
      }
    }));
  } finally {
    setAutoDecodingIds(prev => { const next = new Set(prev); next.delete(messageId); return next; });
  }
};

  // Function to display a success message when jumping
  const showJumpSuccessMessage = (message) => {
    setJumpSuccessMessage(message);
    setTimeout(() => {
      setJumpSuccessMessage(null);
    }, 2000);
  };
  
  const setPresetCoordinates = (x, y) => {
    if (document.getElementById('jump-coordinates')) {
      document.getElementById('jump-coordinates').value = `${x},${y}`;
      setJumpCoordinateInput(`${x},${y}`);
    } else {
      const jumpXInput = document.getElementById('jump-x-coordinate');
      const jumpYInput = document.getElementById('jump-y-coordinate');
      
      if (jumpXInput && jumpYInput) {
        jumpXInput.value = x;
        jumpYInput.value = y;
      }
    }
  };
  
  const goToRandomGridPoint = () => {
    const randX = Math.floor(Math.random() * GRID_SIZE);
    const randY = Math.floor(Math.random() * GRID_SIZE);
    
    setPresetCoordinates(randX, randY);
    
    jumpToCoordinate();
  };

  const resetView = () => {
    mapPositionRef.current = { x: 0, y: 0 };
    
    setFocalMessage(null);
    setIsDraggingFromMessage(false);
    lastMessageCoordinatesRef.current = null;
    dragCountRef.current = 0;
    
    setZoomLevel(1);
    
    updateGridTransform();
    
    setCoordinates({ 
      gridX: GRID_CENTER, 
      gridY: GRID_CENTER 
    });
  };
  
 const switchTab = (tab) => {
  setActiveTab(tab);
  
  if (isMobileView && tab === 'map') {
    // Small delay to ensure tab content is rendered
    setTimeout(() => {
      const element = document.querySelector(`.mobile-tab-content.${tab}`);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
      
      // If there's a jump dot, make sure it's visible
      if (jumpDot) {
        console.log('Map tab active, jump dot should be visible:', jumpDot);
      }
    }, 100);
  }
};
  const renderMobileTabs = () => {
    if (!isMobileView) return null;
    
    return (
      <div className="mobile-tabs">
        <div 
          className={`mobile-tab ${activeTab === 'map' ? 'active' : ''}`}
          onClick={() => switchTab('map')}
        >
          Grid
        </div>
        <div
          className={`mobile-tab ${activeTab === 'controls' ? 'active' : ''}`}
          onClick={() => switchTab('controls')}
        >
          Controls
        </div>
      </div>
    );
  };
  
  const renderMobileActionBar = () => {
    if (!isMobileView) return null;
    
    return (
      <div className="mobile-action-bar">
        {/* <button onClick={resetView}>
          <i className="fa fa-crosshairs"></i>
          Center
        </button> */}
         <button 
        onClick={() => switchTab('map')}
        className={activeTab === 'map' ? 'active' : ''}
      >
        <i className="fa fa-map"></i>
        Grid
      </button>
      <button 
        onClick={() => switchTab('controls')}
        className={activeTab === 'controls' ? 'active' : ''}
      >
        <i className="fa fa-cog"></i>
        Controls
      </button>
        {/* <button onClick={togglePlacementMode}>
          <i className="fa fa-map-pin"></i>
          {isPlacingMessage ? 'Cancel' : 'Place'}
        </button> */}
        
        <button onClick={() => {
          switchTab('controls');
          setTimeout(() => {
            const jumpCoordinatesInput = document.getElementById('jump-coordinates');
            if (jumpCoordinatesInput) jumpCoordinatesInput.focus();
          }, 300);
        }}>
          <i className="fa fa-search"></i>
          Jump
        </button>
      </div>
    );
  };
  
  const renderMobileDragHint = () => {
    if (!isMobileView || !showMobileDragHint) return null;
    
    return (
      <div className="map-drag-hint">
        Explore the Message Map
      </div>
    );
  };
  // Auto-focus on first message when screen loads
  useEffect(() => {
    const focusOnFirstMessage = () => {
      // Only do initial focus once
      if (hasInitialFocusRef.current) return;
      if (filteredMessages.length === 0) return;

      hasInitialFocusRef.current = true;

      const firstMessage = filteredMessages[0];
      const firstX = parseInt(firstMessage.x_coordinate);
      const firstY = parseInt(firstMessage.y_coordinate);

      // Center map on the first message
      setTimeout(() => {
        const firstPos = convertToGridPercentage(firstX, firstY);

        const offsetX = firstPos.x - 50;
        const offsetY = firstPos.y - 50;

        if (gridBackgroundRef.current) {
          const gridRect = gridBackgroundRef.current.getBoundingClientRect();
          const offsetPxX = -offsetX / 100 * gridRect.width;
          const offsetPxY = -offsetY / 100 * gridRect.height;

          mapPositionRef.current.x = offsetPxX;
          mapPositionRef.current.y = offsetPxY;

          updateGridTransform();

          setCoordinates({
            gridX: firstX,
            gridY: firstY
          });

          // Create highlighted jump dot for first message (use grid position, not forced center)
          setJumpDot({
            gridX: firstX,
            gridY: firstY,
            isMessage: true,
            message: firstMessage,
            fromAutoLoad: true,
            key: Date.now()
          });
        }
      }, 500);
    };

    // Focus on first message when messages load
    if (filteredMessages.length > 0) {
      focusOnFirstMessage();
    }
  }, [filteredMessages.length]); // Only trigger when number of messages changes

const renderJumpDot = () => {
  if (!jumpDot) return null;
  
  // Use forced display position if provided, otherwise calculate from grid
  let position;
  if (jumpDot.displayX !== undefined && jumpDot.displayY !== undefined) {
    position = { x: jumpDot.displayX, y: jumpDot.displayY };
  } else {
    position = convertToGridPercentage(jumpDot.gridX, jumpDot.gridY);
  }
  
  // Determine color based on source
  let backgroundColor = 'white';
  if (jumpDot.fromMessageList) backgroundColor = '#00BFFF'; // Blue for message list
  else if (jumpDot.fromAutoLoad) backgroundColor = '#32CD32'; // Green for auto-load
  else if (jumpDot.isMessage) backgroundColor = '#FFA500'; // Orange for found messages
  
  return (
    <div
      key={`jump-dot-${jumpDot.key || Date.now()}`}
      className={`jump-dot ${jumpDot.isMessage ? 'message-found' : ''} ${jumpDot.fromMessageList ? 'from-message-list' : ''} ${jumpDot.fromAutoLoad ? 'from-auto-load' : ''}`}
      style={{
        position: 'absolute',
        left: `${position.x}%`,
        top: `${position.y}%`,
        transform: 'translate(-50%, -50%)',
        zIndex: 1500,
        pointerEvents: 'none',
        width: isMobileView ? '36px' : '28px',
        height: isMobileView ? '36px' : '28px',
        backgroundColor: backgroundColor,
        border: `${isMobileView ? '4px' : '3px'} solid white`,
        borderRadius: '50%',
        opacity: 1,
        animation: 'centerDotPulse 2s infinite',
        cursor: 'default',
        boxShadow: `0 0 15px ${backgroundColor}80` // Semi-transparent glow
      }}
      title={`Message at (${jumpDot.gridX}, ${jumpDot.gridY})`}
    ></div>
  );
};


// Updated CSS with simplified white dot styling
const additionalStyles = `
  @keyframes jumpDotPulse {
    0%, 100% {
      transform: translate(-50%, -50%) scale(1);
      opacity: 1;
      box-shadow: 0 0 20px rgba(255, 255, 255, 0.8), 0 0 40px rgba(255, 255, 255, 0.4);
    }
    50% {
      transform: translate(-50%, -50%) scale(1.2);
      opacity: 0.9;
      box-shadow: 0 0 30px rgba(255, 255, 255, 1), 0 0 60px rgba(255, 255, 255, 0.6);
    }
  }
  
  .jump-dot {
    position: absolute !important;
    z-index: 1000 !important;
    pointer-events: auto !important;
    background-color: white !important;
    border: 3px solid #333 !important;
    width: 24px !important;
    height: 24px !important;
    border-radius: 50% !important;
  }
  
  /* Remove any conflicting styles */
  .jump-dot.message-found,
  .jump-dot.from-jump,
  .jump-dot.from-message-list {
    background-color: white !important;
    border: 3px solid #333 !important;
    width: 24px !important;
    height: 24px !important;
  }
`;
// Add CSS for the persistent dot
  
const renderMessagePopup = () => {
  if (!activePopup) return null;
  const now = Math.floor(Date.now() / 1000);
  const expiresIn = activePopup.message.ttl - now;
  if(expiresIn < 0) return null;

  // Check if message is decoded
  const isDecoded = decodedMessages[activePopup.message.id] !== undefined;

  // Position popup directly at dot with arrow pointing to it
  let popupStyle = {};
  let arrowPosition = 'bottom'; // Arrow points down to dot by default
  let mobilePositionClass = '';

  if (isMobileView) {
    mobilePositionClass = 'popup-mobile-top';
  } else {
    const dotX = activePopup.x; // percentage
    const dotY = activePopup.y; // percentage

    // Vertical positioning - prefer above the dot
    let transformY = 'calc(-100% - 15px)'; // Above dot
    if (dotY < 30) {
      // Dot is near top, place popup below
      transformY = '15px';
      arrowPosition = 'top';
    }

    // Always center popup horizontally on the dot so arrow points to it
    popupStyle = {
      position: 'absolute',
      left: `${dotX}%`,
      top: `${dotY}%`,
      transform: `translate(-50%, ${transformY})`,
      zIndex: 1000
    };
  }

  const popupElement = (
    <div
      className={`message-popup arrow-${arrowPosition} ${mobilePositionClass}`}
      style={popupStyle}
      onClick={(e) => e.stopPropagation()}
      onMouseDown={(e) => e.stopPropagation()}
      onMouseMove={(e) => e.stopPropagation()}
      onMouseUp={(e) => e.stopPropagation()}
      onContextMenu={(e) => e.stopPropagation()}
      onDoubleClick={(e) => e.stopPropagation()}
    >
      <div>
        <strong>Grid Location:</strong> (
        {activePopup.message.x_coordinate},
        {activePopup.message.y_coordinate})
      </div>

      {(() => {
        return (
          <div>
            <strong>Expires:</strong> {
              expiresIn > -1
                ?
                `in ${Math.floor(expiresIn / 60)} ${Math.floor(expiresIn / 60) === 1 ? 'min' : 'mins'}`
                : 'in few seconds'
            }
          </div>
        );
      })()}

      {!isLoggedIn ? (
        <div className="login-prompt">
          <p>Login to view message content</p>
          <button onClick={() => {
            closePopup();
            document.getElementById('payment-id')?.focus();
            if (isMobileView) switchTab('controls');
          }}>Login</button>
        </div>
      ) : autoDecodingIds.has(activePopup.message.id) && !isDecoded ? (
        <div style={{textAlign: 'center', padding: '10px'}}>Decoding message...</div>
      ) : isDecoded && decodedMessages[activePopup.message.id]?.error ? (
        <div style={{color: 'red', padding: '10px'}}>{decodedMessages[activePopup.message.id].error}</div>
      ) : isDecoded && decodedMessages[activePopup.message.id]?.decoded_text ? (
        <div
          style={{padding: '10px', backgroundColor: '#f5f5f5', borderRadius: '5px', marginTop: '10px', maxHeight: isMobileView ? '40vh' : '300px', overflowY: 'auto', WebkitOverflowScrolling: 'touch', touchAction: 'pan-y'}}
          onTouchMove={(e) => e.stopPropagation()}
        >
          <strong>Message:</strong>
          <div className="decoded-message-text" style={{whiteSpace: 'pre-wrap', wordBreak: 'break-word'}}>{decodedMessages[activePopup.message.id].decoded_text}</div>
        </div>
      ) : isDecoded && decodedMessages[activePopup.message.id]?.decoded_audio_base64 ? (
        <div className="audio-controls" style={{marginTop: '10px'}}>
          <div className="audio-label">Audio Message:</div>
          <audio controls src={`data:audio/mp3;base64,${decodedMessages[activePopup.message.id].decoded_audio_base64}`} style={isMobileView ? {width: '100%'} : {}} />
        </div>
      ) : null}

      <button className="close-popup" onClick={closePopup}>
        x
      </button>
    </div>
  );

  if (isMobileView) {
    return ReactDOM.createPortal(popupElement, document.body);
  }
  return popupElement;
};


  const isInteractiveElement = (element) => {
    if (!element) return false;
    
    // Check if the element or any parent is a popup, input, button, or other interactive element
    let current = element;
    while (current && current !== mapRef.current) {
      const tagName = current.tagName?.toLowerCase();
      const className = current.className || '';
      
      // Check for interactive elements
      if (
        tagName === 'input' || 
        tagName === 'button' || 
        tagName === 'textarea' || 
        tagName === 'select' || 
        tagName === 'audio' ||
        className.includes('message-popup') ||
        className.includes('decode-section') ||
        className.includes('copy-button') ||
        className.includes('close-popup') ||
        className.includes('login-prompt') ||
        current.contentEditable === 'true' ||
        current.hasAttribute('contenteditable')
      ) {
        return true;
      }
      
      current = current.parentElement;
    }
    
    return false;
  };
  const renderRecordingControls = () => {
    if (messageType !== 'audio') return null;
    
    return (
      <div className="recording-controls">
        {!isRecording ? (
          <button 
            className="record-button"
            onClick={startRecording}
          >
            Start Recording
          </button>
        ) : (
          <button 
            className="record-button recording"
            onClick={stopRecording}
          >
            Stop Recording ({recordingTime})
          </button>
        )}
        
        <div className="recording-status">{recordingStatus}</div>
        
        {audioPreviewRef.current && (
          <div className="audio-preview">
            <audio controls src={audioPreviewRef.current}></audio>
          </div>
        )}
      </div>
    );
  };
  
const renderJumpCoordinateInput = () => {
  const copyCoordinates = () => {
    const input = document.getElementById('jump-coordinates');
    if (input) {
      navigator.clipboard.writeText(input.value)
        .then(() => {
          const copyButton = document.querySelector('.coordinate-copy-button');
          if (copyButton) {
            copyButton.classList.add('copied');
            setTimeout(() => {
              copyButton.classList.remove('copied');
            }, 2000);
          }
        })
        .catch(err => {
          console.error('Could not copy text: ', err);
        });
    }
  };

  return (
    <div className="form-group">
      <label>Enter OmegaLink:</label>
      <div className="coordinate-field-combined">
        <input 
          type="text" 
          id="jump-coordinates" 
          placeholder=""
          value={jumpCoordinateInput}
          onChange={(e) => setJumpCoordinateInput(e.target.value)}
          onKeyPress={(e) => e.key === 'Enter' && jumpToCoordinate()}
        />
        {/* <div className="coordinate-hint">Enter OmegaLink</div> */}
        <button 
          className="coordinate-copy-button" 
          onClick={copyCoordinates}
          title="Copy coordinates"
          type="button"
        ></button>
      </div>
      {jumpError && <div className="jump-error">{jumpError}</div>}
      <div className="jump-controls">
        <button onClick={jumpToCoordinate}>Jump</button>
      </div>
    </div>
  );
};
const additionalJumpStyles = `
.coordinate-hint {
  font-size: 12px;
  color: #999;
  margin-top: 4px;
  text-align: center;
}

.coordinate-inputs-group {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 12px;
  margin-bottom: 12px;
}

.coordinate-field {
  display: flex;
  flex-direction: column;
}

.coordinate-field label {
  font-size: 12px;
  margin-bottom: 4px;
  font-weight: 500;
}

.coordinate-field input {
  padding: 8px;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-size: 14px;
}

@media (max-width: 768px) {
  .coordinate-inputs-group {
    grid-template-columns: 1fr;
  }
}
`;

  const gridPositionDisplay = `Grid Position: X:${Math.floor(GRID_CENTER + mapPositionRef.current.x/CELL_SIZE)}, Y:${Math.floor(GRID_CENTER + mapPositionRef.current.y/CELL_SIZE)}`;
  
  return (
    <>
      <div className="message-map-container">
        {encodingKeyNotification && (
          <div className="encoding-key-notification">
            <div className="notification-content">
              <div className="notification-header">
                <h3>{encodingKeyNotification.message}</h3>
                <button 
                  className="close-notification"
                  onClick={() => {
                    if (notificationTimeout) {
                      clearTimeout(notificationTimeout);
                    }
                    setEncodingKeyNotification(null);
                  }}
                >
                  ×
                </button>
              </div>
        {/*        <div className="key-display">
  <span id="encoding-key-value">Access Code: {encodingKeyNotification.key}</span>

 <button 
    className="copy-button"
    onClick={(e) => {
      e.stopPropagation();
      copyToClipboard(encodingKeyNotification.key, e.target)}}
  >
    Copy
  </button> 
</div>
<div className="key-display">
  <span id="coordinates-value">Coordinates: {encodingKeyNotification.coordinates}</span>

  <button 
    className="copy-button"
    onClick={(e) => {
      e.stopPropagation();
      copyToClipboard(encodingKeyNotification.coordinates, e.target)}}
  >
    Copy
  </button> 
</div>*/}
<div className="key-display all">
 
  <button 
    className="copy-button copy-all"
     onClick={(e) => {
      e.stopPropagation();
      const xCoord = encodingKeyNotification.coordinates.split(',')[0];
const yCoord = encodingKeyNotification.coordinates.split(',')[1];
const omegaLink = `omega://x=${xCoord}&y=${yCoord}&key=${encodingKeyNotification.key}`;
copyToClipboard(omegaLink, e.target)
     // copyToClipboard(`${encodingKeyNotification.coordinates},${encodingKeyNotification.key}`, e.target)}
    }}
  >
    Copy Your Omega Link
  </button>
</div>
              <div className="notification-timer">
                This notification will close in {Math.ceil(60 - (Date.now() - encodingKeyNotification.timestamp) / 1000)} seconds
              </div>
            </div>
          </div>
        )}
        
        {renderMobileTabs()}
        
        <div className="container">
          <div className={`sidebar ${isMobileView ? `mobile-tab-content ${activeTab === 'controls' ? 'active' : ''}` : ''}`}>
            <div className="title">Message Map Control Panel</div>
            <div className="welcome-text">Welcome to the Global Void!</div>
            
            {!isLoggedIn 
            ? (
              <div className={`controls ${isMobileView ? 'mobile-tab-content controls active' : ''}`}>
                <h3>Viewing in Read-Only Mode - Login to Interact</h3>
                {/* <div className="form-group">
                  <label htmlFor="payment-id">Login ID:</label>
                  <input 
                    type="text" 
                    id="payment-id" 
                    placeholder="Enter your Login ID"
                    value={paymentId}
                    onChange={(e) => setPaymentId(e.target.value)}
                  />
                </div>

                <button 
                  className="login-button" 
                  onClick={handleLogin}
                >
                  Login
                </button> */}
                {/* <div className="login-status" style={{ color: statusColor }}>{loginStatus}</div> */}
                
                {renderJumpCoordinateInput()}
              </div>
            ) :
             (
              <div className={`controls ${isMobileView ? 'mobile-tab-content controls active' : ''}`}>
                <div className="user-info">
                  <div>Logged in as: <span>  {username.length > 7
          ? `${username.slice(0, 5)}${'*'.repeat(username.length - 7)}${username.slice(-2)}`
          : username}</span></div>
                  <div className="token-balance">
                    <i className="token-icon">💰</i> 
                    <span>{userTokens.toLocaleString()} tokens</span>
                  </div>
                  <button 
                    className="logout-button" 
                    onClick={handleLogout}
                  >
                    Logout
                  </button>
                </div>
                
                {renderJumpCoordinateInput()}

                <div className="form-group">
                  <label htmlFor="message-type">Message Type:</label>
                  <select 
                    id="message-type"
                    value={messageType}
                    onChange={(e) => setMessageType(e.target.value)}
                  >
                    <option value="text">Text Message</option>
                    <option value="audio">Audio Message</option>
                  </select>
                </div>
                
                {messageType === 'text' ? (
                  <div className="form-group">
                    <label htmlFor="message-text">Your Message:</label>
                    <textarea 
                      id="message-text" 
                      rows="3" 
                      maxLength="1000" 
                      placeholder="Enter your message (max 1000 chars)"
                      value={messageText}
                      onChange={(e) => setMessageText(e.target.value)}
                    ></textarea>
                  </div>
                ) : (
                  <div className="form-group">
                    <label>Record Audio (max 5 minutes):</label>
                    {renderRecordingControls()}
                  </div>
                )}
                
                <div className="form-group">
                  <label htmlFor="expiration-time">Message Expires After (minutes):</label>
                  <input 
                    type="number" 
                    id="expiration-time" 
                    min="2" 
                    max="60" 
                    value={expirationTime}
                    onChange={(e) => setExpirationTime(parseInt(e.target.value))}
                  />
                  <small>Choose between 2 and 60 minutes</small>
                </div>
                
                <div className="form-group">
                  <label>Message Location:</label>
                  <div>
                    {/* <button onClick={togglePlacementMode}>
                      {isPlacingMessage ? 'Cancel Placement' : 'Click to Place on Map'}
                    </button> */}
                    <button onClick={generateRandomCoordinates}>Use Random Location</button>
                  </div>
                </div>
                
                <div className="form-group coordinate-inputs">
                  <div className="coordinate-fields">
                    <div>
                      <label htmlFor="x-coordinate">Grid X Coordinate:</label>
                      <input 
                        type="number" 
                        id="x-coordinate" 
                        min="0" 
                        max={GRID_SIZE}
                      />
                    </div>
                    <div>
                      <label htmlFor="y-coordinate">Grid Y Coordinate:</label>
                      <input 
                        type="number" 
                        id="y-coordinate" 
                        min="0" 
                        max={GRID_SIZE}
                      />
                    </div>
                  </div>
                </div>
                
                <div className="form-group token-info">
                  <div className="token-cost-info">
                    <div className="token-cost-header">Token Cost:</div>
                    <div className="token-cost-details">
                      <div className={`token-cost-item ${messageType === 'text' ? 'active' : ''}`}>
                        <span>Text Message:</span>
                        <span>1 token</span>
                      </div>
                      <div className={`token-cost-item ${messageType === 'audio' ? 'active' : ''}`}>
                        <span>Audio Message:</span>
                        <span>5 tokens</span>
                      </div>
                    </div>
                    <div className="token-balance-info">
                      <span>Your balance:</span>
                      <span className={userTokens < (messageType === 'audio' ? 5 : 1) ? 'insufficient' : ''}>
                        {userTokens.toLocaleString()} tokens
                      </span>
                    </div>
                  </div>
                </div>
                <button onClick={submitMessage} className="submit-button">Post Message</button>
              </div>
            )}
            
            
            {/* <div className="grid-info">
              <h3>Billion Grid Information</h3>
              <ul>
                <li>The messaging space uses a billion × billion grid system</li>
                <li>Grid coordinates range from 0 to 1,000,000,000</li>
                <li>Grid center is at (500,000,000, 500,000,000)</li>
                <li>Each message is placed at a specific grid point</li>
                <li>Use the jump function to navigate to specific coordinates</li>
              </ul>
            </div> */}
          </div>
          
          <div className={`map-container ${isMobileView ? `mobile-tab-content map ${activeTab === 'map' ? 'active' : ''}` : ''}`}>
            <div className="map-controls">
              <div className="zoom-controls">
                <button onClick={() => handleZoom('in')}>+</button>
                <button onClick={() => handleZoom('out')}>−</button>
                <button onClick={resetView}>R</button>
              </div>
            </div>
            
            <div 
              className="map" 
              id="message-map"
              ref={mapRef}
              onMouseMove={handleMouseMove}
              onClick={handleMapClick}
              onMouseDown={handleMouseDown}
              onTouchStart={handleTouchStart}
              onTouchMove={handleTouchMove}
              onTouchEnd={handleTouchEnd}
            >
              {renderMobileDragHint()}
              {jumpSuccessMessage && (
                <div className="jump-success-message">
                  {jumpSuccessMessage}
                </div>
              )}
              
              <div className="map-border"></div>
              
              <div className="compass">
                <div className="direction n">N</div>
                <div className="direction e">E</div>
                <div className="direction s">S</div>
                <div className="direction w">W</div>
              </div>
              
              <div
                className="grid-background"
                ref={gridBackgroundRef}
                style={{
                  position: 'absolute',
                  top: '-150%',
                  left: '-150%',
                  width: '400%',
                  height: '400%',
                  backgroundSize: '40px 40px, 20px 20px, 20px 20px',
                  transform: `translate(${mapPositionRef.current.x}px, ${mapPositionRef.current.y}px) scale(${zoomLevel})`,
                  transformOrigin: 'center center',
                  zIndex: 1
                }}
              >
                {renderJumpDot()}
                {renderMessages()}
                {renderMessagePopup()}
              </div>

              {gridMoveIndicator.active && (
                <div className={`grid-move-indicator ${gridMoveIndicator.direction}`}>
                  <div className="indicator-arrow"></div>
                  <div className="indicator-text">
                    Moving {gridMoveIndicator.direction.charAt(0).toUpperCase() + gridMoveIndicator.direction.slice(1)}
                  </div>
                </div>
              )}

              <div className="grid-cells"></div>
            </div>
            
            {/* <div className="coordinate-display">
              <div className="coordinates-title">Grid Coordinates</div>
              <div>
                {focalMessage ? (
                  <>
                    Grid X: {focalMessage.x_coordinate}, Grid Y: {focalMessage.y_coordinate}
                    <span className="focused-indicator"> (Focused)</span>
                  </>
                ) : isDraggingFromMessage && lastMessageCoordinatesRef.current ? (
                  <>
                    Grid X: {lastMessageCoordinatesRef.current.x}, Grid Y: {lastMessageCoordinatesRef.current.y}
                    <span className="dragging-indicator"> (Dragging from message)</span>
                  </>
                ) : (
                  <>Grid X: {coordinates.gridX || GRID_CENTER}, Grid Y: {coordinates.gridY || GRID_CENTER}</>
                )}
              </div>
              <div className="grid-position">{gridPositionDisplay}</div>
              <div className="zoom-level">Zoom: {Math.round(zoomLevel * 100)}%</div>
              
              <div className="distance-from-center">
                Distance from center: {Math.sqrt(
                  Math.pow((coordinates.gridX || GRID_CENTER) - GRID_CENTER, 2) + 
                  Math.pow((coordinates.gridY || GRID_CENTER) - GRID_CENTER, 2)
                ).toFixed(0)} units
              </div>
            </div> */}
          </div>
        </div>
       

        {renderMobileActionBar()}
     
      </div>
    </>
  );
}

export default MessageMap;